import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AttachmentDto, AttachmentFileExtension, AttachmentFileType } from './attachment';
import { AttachmentService } from './attachment.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../components/component-base';
import { CoreTranslationService } from '../../services/translation.service';
import { Guid } from 'guid-typescript';

@Component({
  selector: 'app-multi-attachment',
  templateUrl: './multi-attachment.component.html'
})
export class MultiAttachmentComponent extends BaseComponent {
  @Input() labelKey: string;
  @Input() controls: string;
  @Input() isRequired: boolean = false;

  @Input() placeholder!: string;
  @Input() name!: string;
  @Input() validationEnabled!: boolean;
  @Input() attachment!: AttachmentDto;
  @Input() languageSelection: boolean = false;
  @Input() sizeWithKB: number = 6 * 1024 * 1024;
  @Input() maxNumberOfFiles: number = 6;

  @Input() descriptionEnable: boolean = true;
  @Input() acceptedFileTypes: AttachmentFileType[] = [];
  @Output() onSaved = new EventEmitter<AttachmentDto>();
  @Output() onSavedFile = new EventEmitter<File>();
  filesNames: string = "";

  inValidFileExtension: boolean = false;
  sizOrExtensionValidation: boolean = false;
  sizeOfZeroValidation: boolean = false;
  file: File[] = [];
  public allowedFileTypes: string = ''
  public description!: string | null;
  public fileLanguage!: string | null;

  constructor(
    private coreTranslationService: CoreTranslationService,
    private attachmentService: AttachmentService,
    public translate: TranslateService
  ) {
    super();

  }

  public selectAttachment(event: any) {
    this.sizOrExtensionValidation = false;
    this.sizeOfZeroValidation = false;
    this.inValidFileExtension = false;
    let attachments = event.target.files;

    let isValid = true;
    if (attachments.length > 0) {
      for (var i = 0; i < attachments.length; i++) {

        if (this.checkAcceptedSize(attachments[i])
          && this.checkAcceptedTypes(attachments[i])
          && this.checkSizeofzero(attachments[i])) {
          isValid = true;
        }

        else if (!this.checkAcceptedTypes(attachments[i])) {
          this.inValidFileExtension = true
          isValid = false;

        }

        else if (!this.checkSizeofzero(attachments[i])) {
          this.sizeOfZeroValidation = true;
          isValid = false;
        }
        else {
          this.resetFile();
          this.sizOrExtensionValidation = true;
          isValid = false;
        }
      }
      if (isValid) {
        this.file = Array.from(attachments);
            this.filesNames = this.file.length + " " + this.translate.instant("shared.filesAttached");
      }
    }

  }
  ngAfterViewInit() {
    if (this.acceptedFileTypes && this.acceptedFileTypes.length > 0) {
      for (let index = 0; index < this.acceptedFileTypes.length; index++) {
        if (index == this.acceptedFileTypes.length - 1) {
          this.allowedFileTypes = this.allowedFileTypes + AttachmentFileType[this.acceptedFileTypes[index]]

        }
        else {
          this.allowedFileTypes = this.allowedFileTypes + AttachmentFileType[this.acceptedFileTypes[index]] + ','

        }
      }

    }
    this.loadToolTipJs();
  }

  public AddAttachment() {
    this.inValidFileExtension = false;
    if (this.file) {
      for (var i = 0; i < this.file.length; i++) {
        var isAccepted = this.checkAcceptedSize(this.file[i]);
        if (isAccepted) {
          const reader = new FileReader();
          reader.readAsDataURL(this.file[i]);
          let _name = this.file[i].name;
          let _type = this.file[i].type;
          let _size = this.file[i].size;

          reader.onload = () => {
            let newId = Guid.create();
            let res: AttachmentDto = {
              id: newId.toString(),
              fileName: _name,
              extension: '',
              filePath: '',
              contentType: _type,
              fileContent: reader.result.toString().split(',')[1],
              thumbnail: "",
              attachmentTypeId: 0,
              size: _size,
              description: ""
            }
            this.onSaved.emit(res);
            this.onSavedFile.emit(this.file[i]);
            /*this.resetFile();*/
          };

        }
        else {
          this.inValidFileExtension = true;
        }
      }

      this.resetFile();
    }
  }

  public resetFile() {
    this.file = [];
    this.description = null;
    this.fileLanguage = null;
  }

  public AttachmentIsNull() {
    return this.file.length == 0;
  }

  checkAcceptedSize(file: File): boolean {
    let isAccepted = false;
    let fileExtension = file.name.split('.').pop() || '';
    let imageExtensions = AttachmentFileExtension.image.split(',');
    if (imageExtensions.includes(fileExtension)) {
      if (file.size <= this.sizeWithKB)
        isAccepted = true;
    } else {
      if (file.size <= this.sizeWithKB)
        isAccepted = true;
    }
    return isAccepted;

  }


  checkSizeofzero(file: File): boolean {
    let isSizeAccepted = false;
    if (file.size > 0) {
      isSizeAccepted = true;
    }
    else {
      isSizeAccepted = false;
    }
    return isSizeAccepted;
  }
  checkAcceptedTypes(file: File): boolean {
    let isAccepted = false;
    let inValidFileExtension = false;
    if (!this.acceptedFileTypes) isAccepted = true;
    else {
      let fileExtension = file.name.split('.').pop() || '';
      let acceptedExtensions = this.getAcceptedExtensionsOfType;
      if (acceptedExtensions.length == 0) isAccepted = true;
      else isAccepted = acceptedExtensions.includes(fileExtension);
    }

    if (!isAccepted)
      this.inValidFileExtension = true;
    return isAccepted;
  }

  getAttachTooltip() {
    var sizeWithMB = this.sizeWithKB / 1024 / 1024;
    let attachTip = ''
    attachTip = this.translate.instant("shared.allowedattachmenttype") + " " + this.allowedFileTypes
    attachTip += ' ' + this?.translate?.instant("shared.allowedattachmentscount") + " " + this.maxNumberOfFiles + '  '
      + this?.translate?.instant("shared.allowedattachmentssize") + " " + sizeWithMB + ' ' + this?.translate?.instant("shared.mega") + ' ';
    return attachTip;
  }
  get getAcceptedExtensionsOfType(): string[] {
    let acceptedTypesExtentionsString: string = '';

    if (this.acceptedFileTypes) {
      this.acceptedFileTypes.forEach(type => {
        switch (type) {
          case AttachmentFileType.General:
            acceptedTypesExtentionsString =
              AttachmentFileExtension.audio + ','
              + AttachmentFileExtension.video + ','
              + AttachmentFileExtension.image + ','
              + AttachmentFileExtension.pdf + ','
              + AttachmentFileExtension.text + ','
              + AttachmentFileExtension.word + ','
              + AttachmentFileExtension.powerPoint + ','
              + AttachmentFileExtension.commaSeparated + ','
              + AttachmentFileExtension.archiveCompressed; + ','
            break;
          case AttachmentFileType.Document:
            acceptedTypesExtentionsString ?
              acceptedTypesExtentionsString += ','
              + AttachmentFileExtension.text + ','
              + AttachmentFileExtension.commaSeparated + ','
              + AttachmentFileExtension.word + ','
              + AttachmentFileExtension.powerPoint + ','

              : acceptedTypesExtentionsString =
              AttachmentFileExtension.text + ','
              + AttachmentFileExtension.commaSeparated + ','
              + AttachmentFileExtension.word + ','
              + AttachmentFileExtension.powerPoint;

            acceptedTypesExtentionsString =
              + AttachmentFileExtension.text
              + AttachmentFileExtension.commaSeparated
              + AttachmentFileExtension.word
              + AttachmentFileExtension.powerPoint;
            break;
          case AttachmentFileType.Image:
            acceptedTypesExtentionsString ?
              acceptedTypesExtentionsString += ',' + AttachmentFileExtension.image
              : acceptedTypesExtentionsString = AttachmentFileExtension.image;
            break;
          case AttachmentFileType.Audio:
            acceptedTypesExtentionsString ? acceptedTypesExtentionsString += ',' + AttachmentFileExtension.audio
              : acceptedTypesExtentionsString = AttachmentFileExtension.audio;
            break;
          case AttachmentFileType.Video:
            acceptedTypesExtentionsString ?
              acceptedTypesExtentionsString += ',' + AttachmentFileExtension.video
              : acceptedTypesExtentionsString = AttachmentFileExtension.video;
            break;
          case AttachmentFileType.PDF:
            acceptedTypesExtentionsString ?
              acceptedTypesExtentionsString += ',' + AttachmentFileExtension.pdf
              : acceptedTypesExtentionsString = AttachmentFileExtension.pdf;
            break;
          case AttachmentFileType.CommaSeparated:
            acceptedTypesExtentionsString ?
              acceptedTypesExtentionsString += ',' + AttachmentFileExtension.commaSeparated
              : acceptedTypesExtentionsString = AttachmentFileExtension.commaSeparated;
            break;
          case AttachmentFileType.Word:
            acceptedTypesExtentionsString ?
              acceptedTypesExtentionsString += ',' + AttachmentFileExtension.word
              : acceptedTypesExtentionsString = AttachmentFileExtension.word;
            break;
          case AttachmentFileType.PowerPoint:
            acceptedTypesExtentionsString ?
              acceptedTypesExtentionsString += ',' + AttachmentFileExtension.powerPoint
              : acceptedTypesExtentionsString = AttachmentFileExtension.powerPoint;
            break;
          case AttachmentFileType.ArchiveCompressed:
            acceptedTypesExtentionsString ?
              acceptedTypesExtentionsString += ',' + AttachmentFileExtension.archiveCompressed
              : acceptedTypesExtentionsString = AttachmentFileExtension.archiveCompressed;
            break;
          case AttachmentFileType.Text:
            acceptedTypesExtentionsString ?
              acceptedTypesExtentionsString += ',' + AttachmentFileExtension.text
              : acceptedTypesExtentionsString = AttachmentFileExtension.text;
            break;
          case AttachmentFileType.Excel:
            acceptedTypesExtentionsString ?
              acceptedTypesExtentionsString += ',' + AttachmentFileExtension.excel
              : acceptedTypesExtentionsString = AttachmentFileExtension.excel;
            break;
        }
      });
    }

    return acceptedTypesExtentionsString.split(',');
  }


}
